import { reject } from "lodash";

async function loadImage(imageUrl) {
    let imgDim;
    let img;
    const imageLoadPromise = new Promise(resolve => {
        img = new Image();
        img.onload = function () {
            var height = this.height
            var width = this.width
            resolve({ height, width });
        };
        img.src = imageUrl;
    }).then((dim) => {
        imgDim = dim;
    });

    await imageLoadPromise;
    return imgDim;
}

export const validateimg = async (ctrl) => {
    var fileUpload = ctrl;
    if (typeof (fileUpload.files) != "undefined") {
        const readLoadPromise = new Promise((resolve,reject)=>{
            var reader = new FileReader();
            reader.readAsDataURL(fileUpload.files[0]);
            reader.onload = async function (e) {
                var image = new Image();
                image.src = e.target.result;
                const imgDim = await loadImage(image.src);
                var height = imgDim.height;
                var width = imgDim.width;
                if (height != 200 || width != 300) {
                    reject(false);
                } else {
                    resolve(true);
                }
            }
        });
        const sizeValid = await readLoadPromise.then((res)=>{
            return true;
        }).catch((reject)=>{
            alert("Upload image of 300*200 px size.");
            return false;
        });
        return sizeValid
    } else {
        alert("This browser does not support HTML5.");
        return false;
    }
}

export const isEmptyStr =(str)=>{
    if(str){
        return false;
    }else{
        return true;
    }
}
export const checkCharSize =(str, maxLen)=>{
    if(str.length<=maxLen){
        return true;
    }else{
        return false;
    }
}
 